/* @flow */
import React from 'react'
import PropTypes from 'prop-types'
// import { View, StyleSheet } from 'react-native'
import TabOption from './TabOption'
import { View } from '../../Components'
import { Colors } from '../../global'

const styles = {
  tabsContainerStyle: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
  },
  tabStyle: {
    paddingVertical: 5,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderLeftWidth: 0.75,
    borderRightWidth: 0.75,
    borderLeftColor: Colors[800],
    borderRightColor: Colors[600],
  },
  dropShadow: {
    shadowColor: Colors.light,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 0,
    elevation: 1,
  },
}
const handleTabPress = (index: number, selectedIndex: number, onTabPress: Function) => {
  if (selectedIndex !== index) {
    onTabPress(index)
  }
}

const getAccessibilityLabelByIndex = (accessibilityLabels: string[], index: number) =>
  accessibilityLabels && accessibilityLabels.length > 0 && accessibilityLabels[index]
    ? accessibilityLabels[index]
    : undefined

const Segment = ({
  selectedIndex,
  values,
  borderRadius,
  tabsContainerStyle,
  tabsContainerDisableStyle,
  tabStyle,
  dropShadow,
  firstTabStyle,
  lastTabStyle,
  activeTabStyle,
  tabTextStyle,
  activeTabTextStyle,
  onTabPress,
  textNumberOfLines,
  allowFontScaling,
  accessible,
  accessibilityLabels,
  activeTabOpacity,
  enabled,
  ...rest
}) => {
  const firstTabStyleDefault = {
    borderRightWidth: values && values.length > 1 ? 0.75 : 0,
    borderLeftWidth: 0,
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
  }
  const lastTabStyleDefault = {
    borderLeftWidth: 0.75,
    borderRightWidth: 0,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
  }
  const dropShadows = [styles.dropShadow, dropShadow]
  const tabsContainerStyles = [styles.tabsContainerStyle, tabsContainerStyle]
  if (!enabled) {
    tabsContainerStyles.push(tabsContainerDisableStyle)
  }
  return (
    <View style={[dropShadows, tabsContainerStyles]} removeClippedSubviews={false}>
      {values &&
        values.map((item, index) => {
          const accessibilityText = getAccessibilityLabelByIndex(accessibilityLabels, index)
          return (
            <TabOption
              key={item}
              index={index}
              isTabActive={selectedIndex === index}
              text={item}
              textNumberOfLines={textNumberOfLines}
              onTabPress={(indexs) => handleTabPress(indexs, selectedIndex, onTabPress)}
              firstTabStyle={index === 0 ? { ...firstTabStyleDefault, ...firstTabStyle } : {}}
              lastTabStyle={
                index === values.length - 1 ? { ...lastTabStyleDefault, ...lastTabStyle } : {}
              }
              tabStyle={[styles.tabStyle, tabStyle]}
              activeTabStyle={{ ...styles.tabStyle, ...activeTabStyle }}
              tabTextStyle={tabTextStyle}
              activeTabTextStyle={activeTabTextStyle}
              allowFontScaling={allowFontScaling}
              activeTabOpacity={activeTabOpacity}
              accessible={accessible}
              accessibilityLabel={accessibilityText || item}
              enabled={enabled}
            />
          )
        })}
    </View>
  )
}

Segment.defaultProps = {
  values: ['One', 'Two', 'Three'],
  accessible: true,
  accessibilityLabels: [],
  selectedIndex: 0,
  onTabPress: () => {},
  tabsContainerStyle: {},
  tabsContainerDisableStyle: { opacity: 0 },
  tabStyle: {},
  dropShadow: {},
  firstTabStyle: {},
  lastTabStyle: {},
  activeTabStyle: {},
  tabTextStyle: {},
  activeTabTextStyle: {},
  borderRadius: 100,
  textNumberOfLines: 1,
  allowFontScaling: true,
  activeTabOpacity: 1,
  enabled: true,
}
Segment.propTypes = {
  tabStyle: PropTypes.object,
  firstTabStyle: PropTypes.object,
  lastTabStyle: PropTypes.object,
  activeTabStyle: PropTypes.object,
  tabTextStyle: PropTypes.object,
  activeTabTextStyle: PropTypes.object,
  onTabPress: PropTypes.func.isRequired,
  textNumberOfLines: PropTypes.number,
  allowFontScaling: PropTypes.bool,
  accessible: PropTypes.bool,
  activeTabOpacity: PropTypes.number,
  enabled: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.string),
  selectedIndex: PropTypes.number,
  tabsContainerStyle: PropTypes.object,
  tabsContainerDisableStyle: PropTypes.object,
  borderRadius: PropTypes.number,
  accessibilityLabels: PropTypes.arrayOf(PropTypes.string),
}

export default Segment
